import { render, staticRenderFns } from "./address-select.vue?vue&type=template&id=4e91a7a2&scoped=true"
import script from "./address-select.vue?vue&type=script&lang=ts"
export * from "./address-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e91a7a2",
  null
  
)

export default component.exports